export const initialSate = {
    ok: false,
    data: [],
};
